module.exports = __webpack_public_path__ + "static/media/mono_manual_schematic_filter.fe24445d.svg";